import clsx from 'clsx';
import type { CSSProperties } from 'react';

import { Skeleton } from '../foundation/Skeleton';
import type {
  VaniaSkeletonCardProps,
  VaniaSkeletonProps,
  VaniaSkeletonTableProps,
} from './loading.types';

export function VaniaContentSkeleton({ className, style }: VaniaSkeletonProps) {
  return <Skeleton className={clsx('vania-loading-skeleton-content', className)} style={style} />;
}

export function VaniaCardSkeleton({ lines = 3, className, style }: VaniaSkeletonCardProps) {
  return (
    <div className={clsx('vania-loading-skeleton-card', className)} style={style} aria-hidden="true">
      <Skeleton className="vania-loading-skeleton-card__heading" />
      {Array.from({ length: lines }, (_, index) => (
        <Skeleton
          key={`vania-card-skeleton-line-${index}`}
          className="vania-loading-skeleton-card__line"
          style={{ width: index === lines - 1 ? '62%' : '100%' }}
        />
      ))}
    </div>
  );
}

export function VaniaTableSkeleton({ columns = 4, rows = 5, className, style }: VaniaSkeletonTableProps) {
  const tableStyle = {
    ...style,
    '--vania-loading-table-columns': columns,
  } as CSSProperties;

  return (
    <div className={clsx('vania-loading-skeleton-table', className)} style={tableStyle} aria-hidden="true">
      <div className="vania-loading-skeleton-table__row vania-loading-skeleton-table__row--header">
        {Array.from({ length: columns }, (_, index) => (
          <Skeleton key={`vania-table-skeleton-heading-${index}`} />
        ))}
      </div>
      {Array.from({ length: rows }, (_, rowIndex) => (
        <div className="vania-loading-skeleton-table__row" key={`vania-table-skeleton-row-${rowIndex}`}>
          {Array.from({ length: columns }, (_, columnIndex) => (
            <Skeleton key={`vania-table-skeleton-cell-${rowIndex}-${columnIndex}`} />
          ))}
        </div>
      ))}
    </div>
  );
}
